var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlayFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 170.667c0-94.257 76.41-170.667 170.667-170.667h682.667c94.255 0 170.667 76.41 170.667 170.667v682.667c0 94.255-76.412 170.667-170.667 170.667h-682.667c-94.257 0-170.667-76.412-170.667-170.667v-682.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M443.733 665.6l204.8-153.6-204.8-153.6v307.2zM512 170.667c-188.416 0-341.333 152.917-341.333 341.333s152.917 341.333 341.333 341.333c188.416 0 341.333-152.917 341.333-341.333s-152.917-341.333-341.333-341.333zM512 785.067c-150.528 0-273.067-122.539-273.067-273.067s122.539-273.067 273.067-273.067c150.528 0 273.067 122.539 273.067 273.067s-122.539 273.067-273.067 273.067z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayFilled);
export default __webpack_public_path__ + "static/media/icon-play-filled.9504cc195937547a1eddac9b18065684.svg";
export { ForwardRef as ReactComponent };